import { workerConstants } from "../constants";
import { authHeader } from "../helpers";

// Personal API key for the public "publish a discussion" endpoint.
// Contract pinned by bridge: GET | POST | DELETE <WORKER>apikey, Authorization
// header only, no body. POST returns the raw key exactly once - it is never
// logged here and never reaches Redux (see apikey.actions.js).
export const apikeyService = {
    getApiKey,
    generateApiKey,
    revokeApiKey
};

const COMMUNO = workerConstants.WORKER

function getApiKey() {
    return fetch(COMMUNO + "apikey",
        {
            method: 'GET',
            headers: authHeader()
        });
}

function generateApiKey() {
    return fetch(COMMUNO + "apikey",
        {
            method: 'POST',
            headers: authHeader()
        });
}

function revokeApiKey() {
    return fetch(COMMUNO + "apikey",
        {
            method: 'DELETE',
            headers: authHeader()
        });
}
